import { render, staticRenderFns } from "./PieChartChannels.vue?vue&type=template&id=6ee12e82&"
import script from "./PieChartChannels.vue?vue&type=script&lang=js&"
export * from "./PieChartChannels.vue?vue&type=script&lang=js&"
import style0 from "./PieChartChannels.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports